import {
  CHAT_GET_CONTACTS,
  CHAT_GET_CONTACTS_SUCCESS,
  CHAT_GET_CONTACTS_FAILURE,
  CHAT_GET_CONVERSATIONS,
  CHAT_GET_CONVERSATIONS_SUCCESS,
  CHAT_GET_CONVERSATIONS_FAILURE,
  CHAT_CREATE_CONVERSATION,
  CHAT_CREATE_CONVERSATION_SUCCESS,
  CHAT_CREATE_CONVERSATION_FAILURE,
  CHAT_GET_MESSAGES,
  CHAT_GET_MESSAGES_SUCCESS,
  CHAT_GET_MESSAGES_FAILURE,
  CHAT_SEND_MESSAGE,
  CHAT_SEND_MESSAGE_SUCCESS,
  CHAT_SEND_MESSAGE_FAILURE,
  CHAT_RECEIVE_MESSAGE,
  CHAT_SET_ACTIVE_CONVERSATION,
  CHAT_TYPING_START,
  CHAT_TYPING_STOP,
  CHAT_USER_ONLINE,
  CHAT_USER_OFFLINE,
  CHAT_MESSAGE_READ,
  CHAT_ADD_REACTION,
  CHAT_REMOVE_REACTION,
  CHAT_REACTION_ADDED,
  CHAT_REACTION_REMOVED,
  CHAT_EDIT_MESSAGE,
  CHAT_MESSAGE_EDITED,
  CHAT_DELETE_MESSAGE,
  CHAT_MESSAGE_DELETED,
  CHAT_UPLOAD_FILE,
  CHAT_UPLOAD_FILE_SUCCESS,
  CHAT_UPLOAD_FILE_FAILURE,
  CHAT_LOAD_MORE_MESSAGES,
  CHAT_LOAD_MORE_MESSAGES_SUCCESS,
} from "store/constants/Chat";

export const chatGetContacts = () => ({ type: CHAT_GET_CONTACTS });
export const chatGetContactsSuccess = (payload) => ({ type: CHAT_GET_CONTACTS_SUCCESS, payload });
export const chatGetContactsFailure = (payload) => ({ type: CHAT_GET_CONTACTS_FAILURE, payload });

export const chatGetConversations = () => ({ type: CHAT_GET_CONVERSATIONS });
export const chatGetConversationsSuccess = (payload) => ({ type: CHAT_GET_CONVERSATIONS_SUCCESS, payload });
export const chatGetConversationsFailure = (payload) => ({ type: CHAT_GET_CONVERSATIONS_FAILURE, payload });

export const chatCreateConversation = (payload) => ({ type: CHAT_CREATE_CONVERSATION, payload });
export const chatCreateConversationSuccess = (payload) => ({ type: CHAT_CREATE_CONVERSATION_SUCCESS, payload });
export const chatCreateConversationFailure = (payload) => ({ type: CHAT_CREATE_CONVERSATION_FAILURE, payload });

export const chatGetMessages = (payload) => ({ type: CHAT_GET_MESSAGES, payload });
export const chatGetMessagesSuccess = (payload) => ({ type: CHAT_GET_MESSAGES_SUCCESS, payload });
export const chatGetMessagesFailure = (payload) => ({ type: CHAT_GET_MESSAGES_FAILURE, payload });

export const chatSendMessage = (payload) => ({ type: CHAT_SEND_MESSAGE, payload });
export const chatSendMessageSuccess = (payload) => ({ type: CHAT_SEND_MESSAGE_SUCCESS, payload });
export const chatSendMessageFailure = (payload) => ({ type: CHAT_SEND_MESSAGE_FAILURE, payload });

export const chatReceiveMessage = (payload) => ({ type: CHAT_RECEIVE_MESSAGE, payload });

export const chatSetActiveConversation = (payload) => ({ type: CHAT_SET_ACTIVE_CONVERSATION, payload });

export const chatTypingStart = (payload) => ({ type: CHAT_TYPING_START, payload });
export const chatTypingStop = (payload) => ({ type: CHAT_TYPING_STOP, payload });

export const chatUserOnline = (payload) => ({ type: CHAT_USER_ONLINE, payload });
export const chatUserOffline = (payload) => ({ type: CHAT_USER_OFFLINE, payload });

export const chatMessageRead = (payload) => ({ type: CHAT_MESSAGE_READ, payload });

export const chatAddReaction = (payload) => ({ type: CHAT_ADD_REACTION, payload });
export const chatRemoveReaction = (payload) => ({ type: CHAT_REMOVE_REACTION, payload });
export const chatReactionAdded = (payload) => ({ type: CHAT_REACTION_ADDED, payload });
export const chatReactionRemoved = (payload) => ({ type: CHAT_REACTION_REMOVED, payload });

export const chatEditMessage = (payload) => ({ type: CHAT_EDIT_MESSAGE, payload });
export const chatMessageEdited = (payload) => ({ type: CHAT_MESSAGE_EDITED, payload });

export const chatDeleteMessage = (payload) => ({ type: CHAT_DELETE_MESSAGE, payload });
export const chatMessageDeleted = (payload) => ({ type: CHAT_MESSAGE_DELETED, payload });

export const chatUploadFile = (payload) => ({ type: CHAT_UPLOAD_FILE, payload });
export const chatUploadFileSuccess = (payload) => ({ type: CHAT_UPLOAD_FILE_SUCCESS, payload });
export const chatUploadFileFailure = (payload) => ({ type: CHAT_UPLOAD_FILE_FAILURE, payload });

export const chatLoadMoreMessages = (payload) => ({ type: CHAT_LOAD_MORE_MESSAGES, payload });
export const chatLoadMoreMessagesSuccess = (payload) => ({ type: CHAT_LOAD_MORE_MESSAGES_SUCCESS, payload });
